import { take, call, put, takeLatest } from 'redux-saga/effects';
import menuTypes from '../actions/menu.actions';
import { storeMenu } from '../actions/menu.actions';
import { storeUser } from '../actions/auth.actions';
import api from "../api/api";

export function* getMenu() {
    yield takeLatest(menuTypes.GET_MENU, takeLatestMenu);
}

function* takeLatestMenu() {

    let response = yield call(api.get, `/v1/usuarios`, {});
    const menuNavigation = [{
        id: 0,
        name: 'Home',
        to: '/',
        icon: 'cilHome'
    }];

    response.data.result.modulos.map(item => {

        menuNavigation.push({
            id: item.id,
            name: item.nombre,
            to: item.rutaWeb,
            icon: item.icono
        })

        if (item.opciones.length > 0) {

            const index = menuNavigation.length - 1;

            if (!menuNavigation[index].hasOwnProperty('items')) {
                menuNavigation[index].items = [];
            }

            item.opciones.map(submenu => {
                menuNavigation[index].items.push({
                    id: submenu.id,
                    name: submenu.nombre,
                    to: submenu.rutaWeb,
                    icon: submenu.icono
                })
            })
        }
    })

    for(let i=0; i < menuNavigation.length; i++) {
        if (!menuNavigation[i].hasOwnProperty('items') && menuNavigation[i].to == null) {
            menuNavigation[i].to = "/";
        }
    }

    yield put(storeMenu(menuNavigation));
    yield put(storeUser(response.data.result.usuario));
}
